/* pdp.js: builder B. Product page (options, gallery, accordions, quantity, Add to cart, phone Add to cart bar, long
   option lists, Notify me on sold out choices, free shipping progress, Pairs well with and its chooser) and the FAQ
   page (group list and chips, deep links).
   Port of the prototype's js/pdp.js onto Shopify data: #pdp-data (sections/main-product.liquid), the Cart AJAX API
   through ML.cart (cart.js) and the Product Recommendations API. Loads after site.js and cart.js. */
(function () {
  'use strict';
  var ML = window.ML;
  if (!ML) return;
  var root = document.documentElement;
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var hdr = document.getElementById('hdr');
  function hdrH() { return hdr ? Math.round(hdr.getBoundingClientRect().height) : 0; }
  function setHdr() { root.style.setProperty('--hdr-h', hdrH() + 'px'); }
  setHdr();
  window.addEventListener('resize', setHdr);
  var money = ML.money;
  function behave() { return ML.reduce.matches ? 'auto' : 'smooth'; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  var CHECK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  /* ---------- accordions (product pages) ---------- */
  function setAcc(acc, open) {
    var b = $('.acc-h', acc), body = $('.acc-b', acc);
    acc.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (body) body.hidden = !open;
  }
  $$('.acc-h').forEach(function (b) {
    b.addEventListener('click', function () { var acc = b.closest('.acc'); setAcc(acc, !acc.classList.contains('is-open')); });
  });
  $$('a[data-acc]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var acc = document.getElementById(a.getAttribute('data-acc'));
      if (!acc) return;
      e.preventDefault();
      setAcc(acc, true);
      var y = acc.getBoundingClientRect().top + window.pageYOffset - hdrH() - 16;
      window.scrollTo({ top: y, behavior: behave() });
      $('.acc-h', acc).focus({ preventScroll: true });
    });
  });

  var D = null;
  var dataEl = document.getElementById('pdp-data');
  if (dataEl) { try { D = JSON.parse(dataEl.textContent); } catch (e) { D = null; } }
  if (D && $('.buy')) productPage(D);
  pairsRow();
  if ($('.faq')) faqPage();

  /* ======================================================================= product page */
  function productPage(D) {
    var buy = $('.buy');
    var V = (D.variants || []).map(function (v) {
      return { id: v[0], vals: v[1], price: v[2], cmp: v[3], stock: v[4], sale: v[5], mto: v[6], max: v[7], media: v[8], pk: v[9] };
    });
    if (!V.length) return;
    var N = D.options.length;
    var cur = V.filter(function (v) { return v.id === D.current; })[0] || V[0];
    var sel = cur.vals.slice();
    var qty = 1;
    var form = $('form[data-product-form]', buy) || $('.atc-f', buy);
    var idIn = form && form.querySelector('input[name="id"]');
    var qtyIn = form && form.querySelector('input[name="quantity"]');
    var priceEl = $('.buy-p', buy), varEl = $('.buy-v', buy), ptsEl = $('.buy-pts', buy), wasEl = $('.buy-was', buy);
    var stockEl = $('.stock', buy), leadEl = $('.lead', buy), wal = $('.wal', buy);
    var qtyN = $('.qty-n', buy), qtyV = (qtyN && $('[data-qty-v]', qtyN)) || qtyN;
    var msg = $('.atc-msg', buy), status = $('[data-atc-status]', buy);
    var bar = $('.sbar');
    var barP = bar && $('.sbar-p', bar);
    var pkOn = $('[data-pk-on]', buy), pkOff = $('[data-pk-off]', buy);
    var colourIdx = -1;
    D.options.forEach(function (o, i) { if (/^\s*colou?rs?\s*$/i.test(o)) colourIdx = i; });
    function idxOf(name) { return D.options.indexOf(name); }

    function find(s) {
      for (var i = 0; i < V.length; i++) {
        var ok = true;
        for (var j = 0; j < N; j++) if (V[i].vals[j] !== s[j]) { ok = false; break; }
        if (ok) return V[i];
      }
      return null;
    }
    function current() { return find(sel); }
    function maxQty(v) { return v ? (v.max || 99) : 99; }
    function priceFor(oi, val) {
      var s = sel.slice(); s[oi] = val;
      var v = find(s) || V.filter(function (x) { return x.vals[oi] === val; })[0];
      return v ? money(v.price) : '';
    }
    /* a value that cannot be bought with the other choices as they stand: its combination exists and is sold out, or no
       combination with it is for sale (a missing combination is not marked: choosing it moves to one that sells) */
    function isOut(oi, val) {
      var s = sel.slice(); s[oi] = val;
      var v = find(s);
      if (v) return !v.sale;
      return !V.some(function (x) { return x.vals[oi] === val && x.sale; });
    }
    var OUT = ', ' + String(D.sold || 'Sold out').toLowerCase();
    function markOut(el, out) {
      el.classList.toggle('is-out', out);
      if (el.hasAttribute('aria-label') || el.hasAttribute('data-al')) {   /* swatches: the name is the aria-label */
        if (!el.hasAttribute('data-al')) el.setAttribute('data-al', el.getAttribute('aria-label'));
        el.setAttribute('aria-label', el.getAttribute('data-al') + (out ? OUT : ''));
        if (el.hasAttribute('title')) el.setAttribute('title', el.getAttribute('data-al') + (out ? OUT : ''));
        return;
      }
      var t = el.querySelector('.out-t');
      if (out && !t) {
        var first = el.querySelector('span');   /* listbox rows: after the value, before the price */
        var html = '<span class="vh out-t">' + OUT + '</span>';
        if (el.tagName === 'LI' && first) first.insertAdjacentHTML('beforeend', html); else el.insertAdjacentHTML('beforeend', html);
      } else if (!out && t) t.parentNode.removeChild(t);
    }
    /* the variant label beside the price, left out when it only repeats the price (gift card: $10.00 beside $10) */
    function sameAsPrice(label, cents) {
      var n = function (x) { return String(x).replace(/[^0-9.]/g, '').replace(/\.0+$/, ''); };
      return label.indexOf('$') > -1 && /^[\s$\d.,]*(CAD)?\s*$/i.test(label) && n(label) === n(money(cents));
    }

    /* the stock line from data: in stock, available to order (sells with no stock), sold out */
    function paintStock(state) {
      if (!stockEl) return;
      stockEl.hidden = !state;
      if (state) stockEl.setAttribute('data-stock', state);
      $$('[data-st]', stockEl).forEach(function (s) { s.hidden = s.getAttribute('data-st') !== state; });
    }
    /* a note holding a [placeholder] only reaches this page in the theme editor (main-product); mark it Draft there */
    function paintLead(text) {
      if (!leadEl) return;
      leadEl.textContent = text || '';
      leadEl.hidden = !text;
      leadEl.classList.toggle('draft', /\[[^\]]*\]/.test(text || ''));
    }
    /* express checkout buttons stay on; they rest (inert) while the choice cannot be bought */
    function paintWallets(on) {
      if (!wal) return;
      wal.classList.toggle('is-off', !on);
      if (on) wal.removeAttribute('inert'); else wal.setAttribute('inert', '');
    }

    function update(fromUser) {
      var v = current();
      $$('[data-opt][data-val]', buy).forEach(function (b) {
        var on = sel[idxOf(b.getAttribute('data-opt'))] === b.getAttribute('data-val');
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        markOut(b, isOut(idxOf(b.getAttribute('data-opt')), b.getAttribute('data-val')));
      });
      $$('[data-optv]', buy).forEach(function (s) { s.textContent = sel[idxOf(s.getAttribute('data-optv'))]; });
      /* the long list fields and their phone sheets */
      $$('.osel-f', buy).forEach(function (f) {
        var oi = +f.getAttribute('data-oi');
        $('.osel-v', f).textContent = sel[oi];
        if (v) $('.osel-p', f).textContent = money(v.price);
      });
      $$('[role="listbox"][data-oi]').forEach(function (l) {
        var oi = +l.getAttribute('data-oi');
        $$('[role="option"]', l).forEach(function (li) {
          var val = li.getAttribute('data-val');
          var on = val === sel[oi];
          li.classList.toggle('is-on', on);
          li.setAttribute('aria-selected', on ? 'true' : 'false');
          markOut(li, isOut(oi, val));
          var lp = $('.osel-lp', li);
          if (lp && N > 1) lp.textContent = priceFor(oi, val);
          var tick = $('svg', li);
          if (on && !tick) li.insertAdjacentHTML('beforeend', CHECK);
          if (!on && tick) tick.parentNode.removeChild(tick);
        });
      });
      if (!v) {   /* no variant has this mix of values */
        $$('[data-atc]').forEach(function (b) { b.disabled = true; b.textContent = D.atc_off; });
        paintLead(D.unavail);
        paintStock('');
        paintWallets(false);
        paintNotify(null);
        return;
      }
      if (idIn) idIn.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) { wasEl.textContent = v.cmp > v.price ? money(v.cmp) : ''; wasEl.hidden = !(v.cmp > v.price); }
      if (barP) barP.textContent = money(v.price);
      if (varEl) {
        var lab = sel.join(' · ');
        var same = sameAsPrice(lab, v.price);
        varEl.textContent = same ? '' : lab;
        varEl.hidden = same;
      }
      if (ptsEl && D.points) ptsEl.textContent = D.points.replace('{points}', Math.floor(v.price / 100));
      paintStock(!v.sale ? 'out' : v.stock ? 'in' : 'order');
      paintLead(!v.sale ? '' : (v.mto && D.so) ? D.lead_mto : (v.stock && D.so && D.multi) ? D.lead_stock : '');
      paintWallets(v.sale);
      paintNotify(v);
      $$('[data-atc]').forEach(function (b) {
        b.disabled = !v.sale;
        b.textContent = v.sale ? D.atc : (D.sold || D.atc_off);
      });
      if (pkOn && pkOff) {
        var off = v.pk === false;
        pkOn.hidden = off; pkOff.hidden = !off;
      }
      qty = Math.min(qty, maxQty(v));
      paintQty();
      if (fromUser && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* no URL API: leave the address alone */ }
      }
    }

    function choose(oi, val) {
      sel[oi] = val;
      if (!current()) {   /* keep the value just chosen; take the first variant in stock, then for sale, that has it */
        var hits = V.filter(function (v) { return v.vals[oi] === val; });
        var alt = hits.filter(function (v) { return v.stock; })[0] || hits.filter(function (v) { return v.sale; })[0] || hits[0];
        if (alt) sel = alt.vals.slice();
      }
      update(true);
      var v = current();
      if (v && v.media) showMedia(v.media);
    }
    $$('[data-opt][data-val]', buy).forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      b.addEventListener('click', function () { choose(idxOf(b.getAttribute('data-opt')), b.getAttribute('data-val')); });
    });
    $$('.sw-more', buy).forEach(function (more) {
      more.addEventListener('click', function () {
        var box = document.getElementById(more.getAttribute('aria-controls'));
        if (!box) return;
        var open = box.hidden;
        box.hidden = !open;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var first = $('button', box); if (first) first.focus(); }
      });
    });

    /* ---------- quantity ---------- */
    function paintQty() {
      if (!qtyN) return;
      qtyV.textContent = qty;
      if (qtyIn) qtyIn.value = qty;
      var b = $$('.qty-b', buy);
      if (b.length < 2) return;
      b[0].setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');
      b[1].setAttribute('aria-disabled', qty >= maxQty(current()) ? 'true' : 'false');
    }
    $$('.qty-b', buy).forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(maxQty(current()), qty + +b.getAttribute('data-q')));
        paintQty();
      });
    });

    /* ---------- gallery ---------- */
    var gmain = $('.gmain');
    var mainImg = gmain && $('.gwell img', gmain);
    var well = gmain && $('.gwell', gmain);
    var thumbs = $$('.gth');
    var dots = $$('.gdots i');
    var count = $('.gcount');
    var at = 0;
    var M = D.media || {};
    function paintMain(id) {
      var m = M[id];
      if (!m || !mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = m.src;
      if (m.srcset) mainImg.srcset = m.srcset;
      mainImg.alt = m.alt || '';
      /* the frame sizes the photo from its shape and file width: whole, at most 2x (buy.css .gwell) */
      if (well) {
        well.style.setProperty('--ar', m.ar || 1);
        if (m.w) well.style.setProperty('--iw', m.w + 'px');
      }
    }
    function show(i) {
      if (!thumbs.length) return;
      at = (i + thumbs.length) % thumbs.length;
      paintMain(thumbs[at].getAttribute('data-media'));
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === at); t.setAttribute('aria-pressed', j === at ? 'true' : 'false'); });
      dots.forEach(function (d, j) { d.classList.toggle('on', j === at); });
      if (count) count.textContent = (at + 1) + ' / ' + thumbs.length;
      /* one row of thumbnails: bring the chosen one into the strip without moving the page */
      var strip = thumbs[at].parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var t = thumbs[at], l = t.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: behave() });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: behave() });
      }
    }
    /* desktop tiles: the chosen photo moves into the frame (its tile rests while it is there), focus goes to the frame,
       and the frame comes back into view when it has scrolled up under the header */
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () {
        show(j);
        if (!gmain || !ML.mqL.matches) return;
        gmain.focus({ preventScroll: true });
        var top = gmain.getBoundingClientRect().top;
        if (top < hdrH()) window.scrollTo({ top: Math.max(0, top + window.pageYOffset - hdrH() - 16), behavior: behave() });
      });
    });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); }); });
    /* the colour photo swap: a thumbnail that already holds the variant's photo is selected; otherwise the photo goes
       into the variant slot (thumbnail 1, data-vslot, when the page opened on a variant photo) or, with no slot, into the
       frame alone, so no photo of the product is overwritten or shown twice */
    function showMedia(id) {
      id = String(id);
      if (!M[id]) return;
      if (!thumbs.length) { paintMain(id); return; }
      for (var j = 0; j < thumbs.length; j++) if (thumbs[j].getAttribute('data-media') === id) { show(j); return; }
      var t0 = thumbs[0], im = $('img', t0);
      if (!t0.hasAttribute('data-vslot')) {
        paintMain(id);
        at = -1;
        thumbs.forEach(function (t) { t.classList.remove('is-on'); t.setAttribute('aria-pressed', 'false'); });
        dots.forEach(function (d) { d.classList.remove('on'); });
        if (count) count.textContent = '';
        return;
      }
      t0.setAttribute('data-media', id);
      if (im) {
        im.removeAttribute('srcset');
        im.src = M[id].thumb || M[id].src;
        im.alt = M[id].alt || '';
      }
      show(0);
    }
    if (gmain && thumbs.length > 1) {
      gmain.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
      });
      var x0 = null, y0 = 0;
      gmain.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') { x0 = e.clientX; y0 = e.clientY; } });
      gmain.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
      });
      gmain.addEventListener('pointercancel', function () { x0 = null; });
    }

    /* ---------- Add to cart (ML.cart from cart.js; without it the form posts to /cart/add) ---------- */
    var busy = false;
    function addNow(opener) {
      var v = current();
      if (!v || !v.sale || busy) return;
      if (!ML.cart || !ML.cart.add) { if (form) form.submit(); return; }
      busy = true;
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      $$('[data-atc]').forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      ML.cart.add({ id: v.id, quantity: qty }, opener).then(function () {
        /* cleared first, so a second add of the same words is announced again */
        if (status) { status.textContent = ''; requestAnimationFrame(function () { status.textContent = D.added; }); }
      }).catch(function (err) {
        if (msg) { msg.textContent = (err && err.message) || 'Something went wrong. Please try again.'; msg.hidden = false; }
        /* from the phone bar the message is off screen in the buy box: bring it into view and keep focus on a
           button that stays (the bar hides once the buy box button is in view) */
        if (msg && opener && opener.hasAttribute && opener.hasAttribute('data-sbar')) {
          msg.scrollIntoView({ block: 'center', behavior: behave() });
          var main = form && form.querySelector('.atc-b');
          if (main) main.focus({ preventScroll: true });
        }
      }).then(function () {
        busy = false;
        $$('[data-atc]').forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!ML.cart || !ML.cart.add) return;
      e.preventDefault();
      addNow($('.atc-b', form));
    });
    $$('[data-sbar]').forEach(function (b) { b.addEventListener('click', function () { addNow(b); }); });

    /* ---------- Notify me (RET-158): the customer form under Sold out (main-product) ----------
       Shown while the chosen variant cannot be bought; its tag names that variant (notify-me-<id>) for the back in
       stock Flow (RET-183). The post reloads the page and Shopify's return drops the option choice, so the variant is
       remembered (sessionStorage) whenever the form names it and reselected on the way back. The thank you and the
       errors belong to this form only when the return carries its anchor (#product-notify-form): the footer signup is
       a customer form too. */
    var nBox = $('[data-notify]', buy);
    var nForm = nBox && $('[data-notify-form]', nBox);
    var nTags = nBox && $('[data-notify-tags]', nBox);
    var nOk = nBox && $('[data-notify-ok]', nBox);
    var nErr = nBox && $('[data-notify-err]', nBox);
    var nIn = nBox && $('input[type="email"]', nBox);
    var NKEY = 'ml-notify-variant';
    var nDone = null, nErrFor = null;   /* the variant signed up for on this visit; the variant the errors belong to */
    function remember(id) { try { sessionStorage.setItem(NKEY, String(id)); } catch (e) { /* storage off */ } }
    function clearErr() {
      if (nErr) nErr.hidden = true;
      if (nIn) { nIn.removeAttribute('aria-invalid'); nIn.setAttribute('aria-describedby', 'pnot-c'); }
      nErrFor = null;
    }
    function paintNotify(v) {
      if (!nBox) return;
      var out = !!v && !v.sale;
      if (nErrFor !== null && (!v || nErrFor !== v.id)) clearErr();   /* errors go with the first change of choice */
      nBox.hidden = !out;
      if (!out) return;
      if (nTags) nTags.value = 'notify-me,notify-me-' + v.id;
      var done = nDone === v.id;
      if (nForm) nForm.hidden = done;
      if (nOk) nOk.hidden = !done;
      if (!done) remember(v.id);
    }
    if (nForm) nForm.addEventListener('submit', function () {
      var v = current();
      if (!v) return;
      remember(v.id);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) { /* no URL API */ }
    });
    var nBack = !!nBox && window.location.hash === '#product-notify-form';
    var nPosted = nBack && /[?&]customer_posted=true/.test(window.location.search);
    if (nBox && !nBack) {   /* another customer form posted (the footer signup): none of its result is ours */
      if (nErr) { nErr.parentNode.removeChild(nErr); nErr = null; }
      if (nIn && nIn.hasAttribute('data-notify-val')) nIn.value = '';
    }

    /* ---------- free shipping progress (RET-174): the shipping line follows the cart ----------
       main-product (pdp-info) prints it from the cart as the page loads; cart.js fires ml:cart-updated with the cart
       after every add and change. A page reached with Back or Forward and reloaded from the HTTP cache can hold an old
       total, so it reads the cart again (cart.js already refreshes, and fires the event, on a back/forward cache
       restore). Same sums and words as the cart drawer's line. */
    var S = D.ship, shipLi = $('[data-ship]', buy);
    var shipMsg = shipLi && $('[data-ship-msg]', shipLi), shipTrack = shipLi && $('.pship-track', shipLi);
    function paintShip(total) {
      if (!S || !shipMsg || !(S.free > 0) || typeof total !== 'number') return;
      var idle = total <= 0 && !!S.idle, done = total >= S.free;
      shipMsg.textContent = idle ? S.idle : done ? S.done : S.left.replace('{amount}', money(S.free - total));
      if (shipTrack) {
        shipTrack.hidden = idle;
        shipTrack.style.setProperty('--rest', done ? '0%' : (Math.round((S.free - total) * 1000 / S.free) / 10) + '%');
      }
    }
    if (S && shipMsg) {
      document.addEventListener('ml:cart-updated', function (e) { if (e.detail) paintShip(e.detail.total_price); });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) return;
        var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (!nav || nav.type !== 'back_forward') return;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) { if (c) paintShip(c.total_price); })
          .catch(function () { /* the line keeps what the page printed */ });
      });
    }

    /* ---------- phone: the Add to cart bar once the main button has scrolled away ---------- */
    var atc = $('.atc', buy);
    if (bar && atc) {
      var raf = 0;
      var paintBar = function () {
        raf = 0;
        var past = atc.getBoundingClientRect().bottom < hdrH();
        var on = past && !ML.mqL.matches;
        if (bar.hidden === on) bar.hidden = !on;
      };
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paintBar); }, { passive: true });
      window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(paintBar); });
      paintBar();
    }

    /* ---------- long option lists: desktop listbox, phone sheet ---------- */
    $$('.osel-f', buy).forEach(longList);
    function longList(field) {
      var oi = +field.getAttribute('data-oi');
      var list = $('.osel-l', field.parentNode);
      var osm = document.getElementById('osm-' + oi);
      var sheetList = document.getElementById('os-list-' + oi);
      var active = null;
      function opts(l) { return $$('[role="option"]', l); }
      function setAct(l, li) {
        opts(l).forEach(function (o) { o.classList.toggle('is-act', o === li); });
        if (li) {
          l.setAttribute('aria-activedescendant', li.id);
          var r = li.getBoundingClientRect(), lr = l.getBoundingClientRect();
          if (r.top < lr.top) l.scrollTop -= lr.top - r.top;
          else if (r.bottom > lr.bottom) l.scrollTop += r.bottom - lr.bottom;
        }
      }
      function openList() {
        var phone = !ML.mqL.matches && osm && sheetList;
        active = phone ? sheetList : list;
        if (!active) return;
        if (phone) {
          osm.hidden = false; ML.lock(true);
        } else list.hidden = false;
        field.setAttribute('aria-expanded', 'true');
        var cur = $('[aria-selected="true"]', active) || opts(active)[0];
        active.focus();
        setAct(active, cur);
      }
      function closeList(focusField) {
        if (!active) return;
        if (active === sheetList) { osm.hidden = true; ML.lock(false); } else list.hidden = true;
        active = null;
        field.setAttribute('aria-expanded', 'false');
        if (focusField) field.focus();
      }
      function pick(li) { choose(oi, li.getAttribute('data-val')); closeList(true); }
      field.addEventListener('click', function () { if (active) closeList(true); else openList(); });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); openList(); }
      });
      [list, sheetList].forEach(function (l) {
        if (!l) return;
        l.addEventListener('click', function (e) { var li = e.target.closest('[role="option"]'); if (li) pick(li); });
        l.addEventListener('keydown', function (e) {
          var all = opts(l), cur = $('.is-act', l), i = all.indexOf(cur);
          if (e.key === 'ArrowDown') { e.preventDefault(); setAct(l, all[Math.min(all.length - 1, i + 1)]); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setAct(l, all[Math.max(0, i - 1)]); }
          else if (e.key === 'Home') { e.preventDefault(); setAct(l, all[0]); }
          else if (e.key === 'End') { e.preventDefault(); setAct(l, all[all.length - 1]); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (cur) pick(cur); }
          else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeList(true); }
          else if (e.key === 'Tab') { if (l === list) closeList(false); }
          else if (e.key.length === 1) {   /* type to jump */
            var k = e.key.toLowerCase();
            var hit = all.slice(i + 1).concat(all.slice(0, i + 1)).filter(function (o) { return o.textContent.trim().toLowerCase().charAt(0) === k; })[0];
            if (hit) setAct(l, hit);
          }
        });
      });
      if (osm) {
        var scrim = $('.os-scrim', osm), x = $('.os-top .ibtn', osm);
        if (scrim) scrim.addEventListener('click', function () { closeList(true); });
        if (x) x.addEventListener('click', function () { closeList(true); });
        osm.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { e.stopPropagation(); closeList(true); }
          if (e.key === 'Tab') {   /* two stops in the sheet: the close button and the list */
            e.preventDefault();
            (document.activeElement === sheetList ? x : sheetList).focus();
          }
        });
      }
      if (list) list.addEventListener('focusout', function (e) {
        if (active !== list) return;
        var to = e.relatedTarget;
        if (to && (list.contains(to) || to === field)) return;
        closeList(false);
      });
      document.addEventListener('pointerdown', function (e) {
        if (active === list && list && !list.contains(e.target) && !field.contains(e.target)) closeList(false);
      });
      if (ML.mqL.addEventListener) ML.mqL.addEventListener('change', function () { closeList(false); });
    }

    /* ---------- ?colour=<Name>: open on that colour, its first variant in stock ---------- */
    var want = null;
    try { want = new URLSearchParams(location.search).get('colour'); } catch (e) { want = null; }
    /* open on a variant: its values chosen, its photo shown, and a chosen swatch inside the closed More box shown */
    function openOn(pv) {
      sel = pv.vals.slice();
      if (pv.media) showMedia(pv.media);
      update(false);
      var on = $$('[data-opt][data-val]', buy).filter(function (b) { return b.classList.contains('is-on') && b.closest('[hidden]'); })[0];
      var box = on && on.closest('[hidden]');
      if (box && box.classList.contains('sws-x')) {
        box.hidden = false;
        var mb = $('[aria-controls="' + box.id + '"]');
        if (mb) mb.setAttribute('aria-expanded', 'true');
      }
    }
    if (want && colourIdx >= 0) {
      var w = want.trim().toLowerCase();
      var hits = V.filter(function (v) { return v.vals[colourIdx].toLowerCase() === w; });
      var pv = hits.filter(function (v) { return v.stock; })[0] || hits.filter(function (v) { return v.sale; })[0] || hits[0];
      if (pv) openOn(pv);
    }
    /* back from Notify me: the option signed up for, then the thank you (posted) or this form's errors */
    if (nBack) {
      var rid = null;
      try { rid = sessionStorage.getItem(NKEY); } catch (e) { rid = null; }
      var rv = rid && V.filter(function (x) { return String(x.id) === rid; })[0];
      if (rv) openOn(rv);
      var nv = current();
      if (nPosted) {
        try { sessionStorage.removeItem(NKEY); } catch (e) { /* storage off */ }
        if (nv) nDone = nv.id;
      } else if (nErr && nv) {
        nErrFor = nv.id;
        nErr.hidden = false;
        if (nIn) { nIn.setAttribute('aria-invalid', 'true'); nIn.setAttribute('aria-describedby', 'pnot-err pnot-c'); }
      }
    }
    update(false);
    if (nBack) {
      if (nPosted && nBox && nBox.hidden) {   /* the option is not known (no storage): the thank you on its own */
        nBox.hidden = false;
        if (nForm) nForm.hidden = true;
        if (nOk) nOk.hidden = false;
      }
      /* a refresh starts clean, on the same option */
      try {
        var bu = new URL(window.location.href), bv = current();
        bu.searchParams.delete('customer_posted');
        if (bv) bu.searchParams.set('variant', bv.id);
        bu.hash = '';
        history.replaceState(history.state, '', bu.toString());
      } catch (e) { /* no URL API */ }
      if (nBox && !nBox.hidden) {
        var nFocus = nPosted ? nOk : (nErr && !nErr.hidden ? nIn : null);
        requestAnimationFrame(function () {
          nBox.scrollIntoView({ block: 'center', behavior: 'auto' });
          if (nFocus) nFocus.focus({ preventScroll: true });
        });
      }
    }
  }

  /* ======================================================================= Pairs well with */
  function pairsRow() {
    var sec = $('.pdp-pairs[data-recs]');
    if (!sec) return;
    var base = sec.getAttribute('data-recs');
    function get(intent) {
      return fetch(base + '&intent=' + intent, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('[data-pairs-grid]');
        return g && g.querySelector('.card') ? g : null;
      });
    }
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    var self = sec.getAttribute('data-self') || '';
    var tpl = $('template[data-pairs-fill]', sec);
    /* the API's cards first, then the department's best sellers until the row holds the limit; hidden under two */
    function fill(g) {
      var grid = $('[data-pairs-grid]', sec);
      var seen = {}, cards = [];
      seen[self] = true;
      function take(list) {
        for (var i = 0; i < list.length && cards.length < limit; i++) {
          var c = list[i], h = c.getAttribute('data-h') || ($('a', c) || c).getAttribute('href') || '';
          if (seen[h]) continue;
          seen[h] = true;
          cards.push(c);
        }
      }
      if (g) take(g.querySelectorAll('.card'));
      if (tpl) take(tpl.content.querySelectorAll('.card'));
      if (cards.length < 2) return;
      grid.innerHTML = '';
      cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
      sec.hidden = false;
      if (ML.updateArrows) ML.updateArrows();
    }
    var go = function () {
      get('complementary').then(function (g) {
        if (g && g.querySelectorAll('.card').length >= limit) return g;
        return get('related').then(function (r) {
          if (!g) return r;
          if (r) $$('.card', r).forEach(function (c) { g.appendChild(c); });
          return g;
        }, function () { return g; });
      }).then(fill, function () { fill(null); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        go();
      }, { rootMargin: '0px 0px 600px 0px' });
      /* the section is hidden until filled, so watch the buy box end instead */
      io.observe($('.accs') || $('.buy') || document.body);
    } else go();

    /* quick add on a product with options: a small chooser instead of adding the first variant */
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.pdp-pairs button[data-qadd]') : null;
      if (!b || +(b.getAttribute('data-variants') || 1) <= 1) return;
      e.preventDefault();
      e.stopPropagation();
      chooser(b.getAttribute('data-url'), b);
    }, true);
  }

  var qchm = null;
  function chooser(url, opener) {
    if (!url) return;
    fetch(url.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (P) {
      var sale = (P.variants || []).filter(function (v) { return v.available; });
      if (!sale.length) return;
      if (qchm) qchm.parentNode.removeChild(qchm);
      var first = sale[0];
      var label = (P.options || []).map(function (o) { return o.name || o; }).join(' and ');
      qchm = document.createElement('div');
      qchm.className = 'qchm';
      var opts = sale.map(function (v, i) {
        return '<option value="' + i + '"' + (v === first ? ' selected' : '') + '>' + esc(v.title) + ', ' + money(v.price) + '</option>';
      }).join('');
      var X = $('.cart-x') ? $('.cart-x').innerHTML : '&times;';
      qchm.innerHTML = '<div class="qch-scrim" aria-hidden="true"></div><div class="qch" role="dialog" aria-modal="true" aria-labelledby="qch-t" tabindex="-1">' +
        '<div class="qch-top"><h2 class="lbl" id="qch-t">' + esc(P.title) + '</h2><button type="button" class="ibtn qch-x" aria-label="Close">' + X + '</button></div>' +
        '<p class="qch-p">' + money(first.price) + '</p><label class="qch-f"><b>' + esc(label) + '</b><select>' + opts + '</select></label>' +
        '<p class="mute qch-s" role="status"></p><button type="button" class="atc-b">Add to cart</button></div>';
      (document.querySelector('.page') || document.body).appendChild(qchm);
      var dlg = $('.qch', qchm), select = $('select', qchm), price = $('.qch-p', qchm);
      select.addEventListener('change', function () { price.textContent = money(sale[+select.value].price); });
      ML.lock(true);
      var untrap = ML.trap(dlg, function () { close(); });
      function close(back) {
        if (!qchm) return;
        untrap();
        qchm.parentNode.removeChild(qchm);
        qchm = null;
        ML.lock(false);
        if (back !== false && opener) opener.focus();
      }
      $('.qch-x', qchm).addEventListener('click', function () { close(); });
      $('.qch-scrim', qchm).addEventListener('click', function () { close(); });
      $('.atc-b', qchm).addEventListener('click', function () {
        var v = sale[+select.value];
        close(false);
        ML.add(v.id, 1, opener);
      });
      select.focus();
    }).catch(function () { window.location.href = url; });
  }

  /* ======================================================================= FAQ */
  /* the answers are always open (main-faq .fq2); a #q- link or a group link scrolls under the header and moves focus */
  function faqPage() {
    var navLinks = $$('.faq-nav a'), chips = $$('.faq-chips .chip');
    var spyOff = 0;
    function mark(id) {
      navLinks.concat(chips).forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-on', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      var chip = chips.filter(function (c) { return c.classList.contains('is-on'); })[0];
      if (chip && chip.parentNode.scrollWidth > chip.parentNode.clientWidth) {
        chip.parentNode.scrollTo({ left: chip.offsetLeft - 8, behavior: behave() });
      }
    }
    function go(id, focus) {
      var el = document.getElementById(id);
      if (!el) return;
      var g = el.classList.contains('fq-g') ? el : el.closest('.fq-g');
      var q = el.classList.contains('fq2-q');
      var y = el.getBoundingClientRect().top + window.pageYOffset - hdrH() - 16;
      window.scrollTo({ top: Math.max(0, y), behavior: behave() });
      if (g) mark(g.id);
      /* a question (a #q- deep link) always takes focus at its heading; a group when it was chosen from the list */
      if (focus || q) {
        var t = q ? $('.fq2-qt', el) : $('.fq-gt', el);
        if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
      }
    }
    navLinks.concat(chips).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var id = a.getAttribute('href').slice(1);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
        spyOff = Date.now();
        go(id, true);
      });
    });
    function fromHash() {
      var id = '';
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { id = ''; }
      if (id && document.getElementById(id)) go(id, false);
    }
    window.addEventListener('hashchange', fromHash);
    if (location.hash) { if (document.readyState === 'complete') fromHash(); else window.addEventListener('load', fromHash); }
    /* desktop: the group you are reading is underlined in the list */
    var groups = $$('.fq-g');
    window.addEventListener('scroll', function () {
      if (!ML.mqL.matches || Date.now() - spyOff < 900 || !groups.length) return;
      var line = hdrH() + 120, cur = groups[0];
      groups.forEach(function (g) { if (g.getBoundingClientRect().top <= line) cur = g; });
      navLinks.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + cur.id;
        a.classList.toggle('is-on', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
    }, { passive: true });
  }
})();
